// @ts-nocheck
import React from "react";

interface Props {
    stroke: string;
}
const Chart: React.FC<Props> = ({ stroke }) => {
    return (
        <svg
            stroke={stroke}
            fill={stroke}
            xmlns="http://www.w3.org/2000/svg"
            version="1.0"
            x="0px"
            y="0px"
            viewBox="0 0 26 26"
            // style="enable-background:new 0 0 26 26;"
        >
            <g>
                <path d="M23,2h-9V1c0-0.552-0.447-1-1-1c-0.552,0-1,0.448-1,1v1H3C1.344,2,0,3.343,0,5v13c0,1.656,1.344,3,3,3h9v0.382   l-5.447,2.724c-0.494,0.247-0.694,0.848-0.447,1.342c0.247,0.494,0.846,0.694,1.342,0.447L12,23.618V24c0,0.553,0.448,1,1,1   c0.553,0,1-0.447,1-1v-0.382l4.553,2.276C18.696,25.966,18.849,26,18.999,26c0.367,0,0.72-0.202,0.896-0.553   c0.247-0.494,0.047-1.095-0.447-1.342L14,21.382V21h9c1.656,0,3-1.344,3-3V5C26,3.343,24.656,2,23,2z M24,18H2V5h22V18z"></path>
                <path d="M5.707,13.707l1.928-1.928l1.437,3.592c0.143,0.356,0.477,0.6,0.859,0.627C9.954,15.999,9.977,16,10,16   c0.357,0,0.689-0.19,0.868-0.504l3.351-5.863l2.074,2.074c0.391,0.391,1.023,0.391,1.414,0l4-4c0.391-0.391,0.391-1.023,0-1.414   s-1.023-0.391-1.414,0L17,9.586l-2.293-2.293c-0.22-0.22-0.531-0.326-0.84-0.284s-0.581,0.225-0.735,0.495l-2.973,5.202   l-1.23-3.077C8.804,9.316,8.53,9.088,8.201,9.021c-0.329-0.066-0.67,0.036-0.908,0.272l-3,3c-0.391,0.391-0.391,1.023,0,1.414   S5.316,14.098,5.707,13.707z"></path>
            </g>
        </svg>
    );
};

export default Chart;
